import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    document.addEventListener(
      "turbo:before-fetch-request",
      this.handleBeforeFetch,
    );
  }

  disconnect() {
    document.removeEventListener(
      "turbo:before-fetch-request",
      this.handleBeforeFetch,
    );
  }

  handleBeforeFetch = (event) => {
    const target = event.target;
    if (!target) return;

    const method = target.getAttribute("method");
    if (method !== "delete") return;

    const action = target.getAttribute("action");
    if (!action || !action.includes("/cart_items/")) return;

    const parts = action.split("/");
    if (parts.length < 2) return;

    const id = parts[parts.length - 1];
    if (!id) return;

    const row = document.getElementById("cart_item_" + id);
    if (row) {
      row.classList.add("deleting");
    }
  };
}
